<template>
  <div class="second" :class="{ bt: over }">
    <div class="wrapper">
      <div class="left">
        <p class="sub-title">Company<br />Profile</p>
        <p class="title">公司简介</p>
        <p class="desc" :class="{ over: over }">
          {{ filterText(data.intro, 150) }}
        </p>
        <router-link
          v-show="over"
          :to="{ path: '/about' }"
          class="more"
          tag="div"
          id="more"
          @mouseover.native="mouseenter"
          @mouseleave.native="mouseleave"
          ><span>MORE <i class="el-icon-arrow-right"></i></span>
        </router-link>
        <div class="numbers">
          <div>
            <span>
              <countTo
                :start-val="0"
                :endVal="data.year"
                :duration="4000"
              ></countTo>
              年
            </span>

            <br />
            <label>成立</label>
          </div>
          <div>
            <span>
              <countTo
                class="cont"
                :start-val="0"
                :endVal="data.server"
                :duration="200"
              ></countTo>
              家
            </span>

            <br />
            <label>提供服务</label>
          </div>
          <div>
            <span>
              <countTo
                class="cont"
                :start-val="0"
                :endVal="data.person"
                :duration="1500"
              ></countTo>
              人
            </span>

            <br />
            <label>解决就业</label>
          </div>
        </div>
      </div>
      <div class="right pc">
        <img :src="data.img" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { company_profile } from '../../utils/api'
export default {
  props: ['over'],
  data() {
    return {
      data: {},
    }
  },
  mounted() {
    // 公司简介
    company_profile((r) => {
      this.data = r.data
    })
  },
  methods: {
    mouseleave() {
      setTimeout(() => {
        document.getElementById('more').style.borderColor = '#1a1a1a'
      }, 800)
    },
    mouseenter() {
      document.getElementById('more').style.borderColor = 'transparent'
    },
  },
}
</script>

<style lang="less" scoped >
.second.bt {
  padding-bottom: 136px;
}
.second {
  background: url('../../assets/bg_city.png') no-repeat;
  background-size: cover;
  padding: 80px 0;
  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .left {
      width: 628px;

      .sub-title {
        font-size: 18px;
        font-family: Arial;
        font-weight: 400;
        line-height: 21px;
        color: #909090;
      }

      .title {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 40px;
        color: #1a1a1a;
        position: relative;
        margin-bottom: 51px;
        margin-top: 20px;
      }

      .title::after {
        width: 80px;
        height: 4px;
        background: #006C8F;
        position: absolute;
        left: 0;
        bottom: -10px;
        content: '';
      }
      .desc.over {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
      }
      .desc {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 28px;
        color: #4d4d4d;
        margin-top: 40px;
        white-space: pre-wrap;
        margin-bottom: 29px;
      }

      .more {
        width: 200px;
        height: 40px;
        border: 1px solid #1a1a1a;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        position: relative;
        overflow: hidden;
        transition: border-color 0s ease-in 0s;
        margin-bottom: 85px;
      }
      .more:before {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        border: 2px solid transparent;
        width: 0;
        height: 0;
        box-sizing: border-box;
        z-index: 1;
        /*
      css3的transition是有兼容性的，所以尽量用现代浏览器,也可以添加-webkit-、-o-、-ms-、-moz-在属性前面，例如：
      -webkit-transition:width 1s linear 2s;
      */
        /*
       我用的transition是个简化属性，值有4个。
       语法：
       transition：property duration timing-function delay
       ||(等同于四句属性)
       transition-property:val||all//注释：设置过渡效果的css属性的名称，如果设置all就是指全部css属性
       transition-duration:val//注释：完成过渡效果需要多少秒或多少毫秒，例如：transition-duration:1s或者是1000ms
       transition-timing-function:linear|ease|ease-in|ease-out|ease-in-out|cubic-
bezier(n,n,n,n);//注释：过渡效果的速度曲线？
        linear    规定以相同速度开始至结束的过渡效果（等于 cubic-bezier(0,0,1,1)）。
        ease    规定慢速开始，然后变快，然后慢速结束的过渡效果（cubic-bezier(0.25,0.1,0.25,1)）。
        ease-in    规定以慢速开始的过渡效果（等于 cubic-bezier(0.42,0,1,1)）。
        ease-out    规定以慢速结束的过渡效果（等于 cubic-bezier(0,0,0.58,1)）。
        ease-in-out    规定以慢速开始和结束的过渡效果（等于 cubic-bezier(0.42,0,0.58,1)）。
        cubic-bezier(n,n,n,n)    在 cubic-bezier 函数中定义自己的值。可能的值是 0 至 1 之间的数值。
       transition-delay:val//注释：定义过渡效果从何时开始
      */
        transition: border-color 0s ease-in 0.8s, width 0.2s ease-in 0.6s,
          height 0.2s ease-in 0.4s;
      }
      .more:after {
        content: '';
        display: block;
        position: absolute;
        right: 0;
        bottom: 0;
        width: 0;
        height: 0;
        border: 2px solid transparent;
        box-sizing: border-box;
        z-index: 1;
        /*
        鼠标移开目的地，以下面的transition属性为准来过渡，请好好理解下面的属性!一旦弄懂了它，就会做了
      */
        transition: border-color 0s ease-out 0.4s, width 0.2s ease-out 0.2s,
          height 0.2s ease-out 0s;
      }
      .more:hover:after,
      .more:hover:before {
        width: 100%;
        height: 100%;
      }
      .more:hover:before {
        border-top-color: #006C8F;
        border-right-color: #006C8F;
        transition: border-color 0s ease-out 0s, width 0.2s ease-out 0s,
          height 0.2s ease-out 0.2s;
      }
      .more:hover:after {
        border-bottom-color: #006C8F;
        border-left-color: #006C8F;
        /*
        鼠标移入目的地，以下面的transition属性为准来过渡，请好好理解下面的属性!一旦弄懂了它，就会做了
      */
        transition: border-color 0s ease-out 0.4s, width 0.2s ease-out 0.4s,
          height 0.2s ease-out 0.6s;
      }
      .more:hover {
        color: #006C8F;
        span {
          position: relative;
          z-index: 1;
        }
      }

      .numbers {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 28px;
        color: #1a1a1a;

        div {
          text-align: center;

          & > span {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 28px;
            color: #1a1a1a;

            .cont {
              display: inline-block;
              margin-right: 25px;
            }

            span {
              font-size: 46px;
              font-family: DIN;
              font-weight: 400;
              color: #006C8F;
              position: relative;
            }

            .cont::after {
              content: '+';
              position: absolute;
              right: -32px;
              bottom: 0;
            }
          }

          label {
            font-size: 26px;
            display: block;
            margin-top: 22px;
          }
        }
      }
    }

    .right {
      width: 436px;
      height: 604px;
      // border: 4px solid #006C8F;
      box-sizing: border-box;
      position: relative;

      img {
        width: 100%;
        height: 604px;
        vertical-align: middle;
        position: relative;
        z-index: 1;
        // left: -56px;
        // top: -56px;
      }
    }
    .right::after {
      content: '';
      width: 436px;
      height: 604px;
      border: 4px solid #006C8F;
      box-sizing: border-box;
      position: absolute;
      right: -56px;
      bottom: -56px;
    }
  }
}
@media (max-width: 767px) {
  .second {
    box-sizing: border-box;
    .wrapper {
      width: 100%;
      .left {
        width: 100%;
        .sub-title {
          font-size: 0.28rem;
        }
        .title {
          font-size: 0.4rem;
          margin-top: 0.12rem;
          margin-bottom: 0.54rem;
          line-height: 0.32rem;
        }
        .desc {
          margin-top: 0.54rem;
          box-sizing: border-box;
          font-size: 0.28rem;
        }
        .more {
          width: 2.4rem;
          height: 0.6rem;
          font-size: 0.28rem;
          margin-top: 0.34rem;
          margin-bottom: 0.68rem;
        }
        .numbers {
          margin-top: 0.68rem;
          div {
            & > span {
              font-size: 0.24rem;
              span {
                font-size: 0.48rem;
              }
              .cont {
                margin-right: 0.2rem;
              }
              .cont::after {
                right: -0.26rem;
                font-weight: bold;
              }
            }
            label {
              margin-top: 0.16rem;
              font-size: 0.3rem;
            }
          }
        }
      }
    }
  }
}
</style>